import { Component, Vue} from 'vue-property-decorator';
import { POSTBACKS_METRICS } from './columns'

@Component
export default class PostbacksMetricsMixin extends Vue {
  get postbacksMetrics()  {
    return{
      order: POSTBACKS_METRICS.order,
      avaliable_metrics: POSTBACKS_METRICS.allColumns,
      default_omit: POSTBACKS_METRICS.defaultUnselected,
      default_include: POSTBACKS_METRICS.defaultSelected,
      default_sort: POSTBACKS_METRICS.defaultSort,
      metrics_help: {
        'postbacks-timestamp': {
          short: this.t('Date and time of postback request'),
          full: this.t('Date and time of postback request')+'.',
        },
        'postbacks-clickid': {
          short: this.t('Unique click ID'),
          full: this.t('Unique click ID value of conversion passed via postback. This value contains 22 alpha-numeric symbols.'),
        },
        'postbacks-url': {
          short: this.t('Postback link'),
          full: this.t('Link of traffic source postback configured in traffic source settings.'),
        },
        'postbacks-status_code': {
          short: this.t('The status code sent by the traffic source server.'),
          full: this.t('The status code sent by the traffic source server.<br><b>200</b> – The conversion data was successfully forwarded to the traffic source.<br><b>400</b> – The conversion data was not forwarded to the traffic source.<br><b>400-499</b> – The conversion data wasn’t accepted by the traffic source due to the incorrect request.'),
        },
        'postbacks-body': {
          short: this.t('The data forwarded by the traffic source server to BeMob in response to a request to accept the conversion data.'),
          full: this.t('The data forwarded by the traffic source server to BeMob in response to a request to accept the conversion data.')
        },
        'postbacks-headers': {
          short: this.t('A part of the server response that helps determine how the received data should be processed.'),
          full: this.t('A part of the server response that helps determine how the received data should be processed.')
        },
        'postbacks-error': {
          short: this.t('Reason of request failure'),
          full: this.t('If the postback request is not passed, the reason will be displayed in Error column.'),
        },
        'campaigns-id': {
          short: this.t('Unique ID of campaign'),
          full: this.t('The unique ID is assigned to each campaign in tracker. This ID will be displayed in the campaign URL.')
        },
        'campaigns-name': {
          short: this.t('Name of the campaign'),
          full: this.t('The campaign name is based on selected traffic source, country tag and unique custom name. Name preferences should be set up in Settings -> General -> Reporting.')
        },
        'landings-id': {
          short: this.t('Unique ID of landing page'),
          full: this.t('The unique ID is assigned to each landing page in tracker.')
        },
        'landings-name': {
          short: this.t('Name of the landing page'),
          full: this.t('The  landing page name is based on country tag and unique custom name. Name preferences for landing page name in report  should be set up in Settings -> General -> Reporting.')
        },
        'offers-id': {
          short: this.t('Unique ID of offer'),
          full: this.t('Unique ID assigned to the offer in tracker.')
        },
        'offers-name': {
          short: this.t('Name of offer'),
          full: this.t('The offer name is based on country tag and unique custom name. Name preferences for offer name in report should be set up in Settings -> General -> Reporting.')
        },
        'traffic_sources-id': {
          short: this.t('Unique ID of traffic source'),
          full: this.t('The unique ID is assigned to each traffic source in tracker.')
        },
        'traffic_sources-name': {
          short: this.t('Official or custom name of traffic source'),
          full: this.t('If traffic source is added from the template, the name will be pre-filled with the official name of traffic source. Also custom name can be added in traffic source settings.')
        },
        'affiliate_networks-id': {
          short: this.t('Unique ID of affiliate network'),
          full: this.t('Unique ID assigned to the affiliate network in tracker.')
        },
        'affiliate_networks-name': {
          short: this.t('Official or custom name of affiliate network'),
          full: this.t('If affiliate network is added from the template, the name will be pre-filled with the official name of affiliate network. Also custom name can be added in affiliate network settings.')
        },
        'flows-name': {
          short: this.t('Name of the flow associated to the event'),
          full: `${this.t('Name of the flow associated to the event')}.`,
        },
        'flows-id': {
          short: this.t('Unique ID of the flow associated to the event'),
          full: `${this.t('Unique ID of the flow associated to the event')}.`,
        },
        'postbacks-status': {
          short: this.t('✅ – Postback with conversion data sent from BeMob.<br> ❌ – Postback with conversion data failed to send from BeMob.'),
          full: `${this.t('✅ – Postback with conversion data sent from BeMob.<br> ❌ – Postback with conversion data failed to send from BeMob.')}.`,
        },
      },
      metrics_options: POSTBACKS_METRICS.weight,
      sort_exclude: POSTBACKS_METRICS.sortExclude

    } as Bemob.Metrics;
}
}
